import React from "react";
import {
  Drawer,
  Box,
  Typography,
  IconButton,
  useMediaQuery,
  useTheme,
  Grid,
  Divider,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { motion } from "framer-motion";

const MotionBox = motion(Box);

const labelStyle = {
  fontWeight: "bold",
  color: "#555",
  marginBottom: "4px",
};

const valueStyle = {
  color: "#222",
};

const CourseDetailsDrawer = ({ open, courseDetailsToggleDrawer, course }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const drawerWidth = isMobile ? "90vw" : 500;
  // Helper: Convert HTML to plain text
  const stripHtml = (html) => {
    const div = document.createElement("div");
    div.innerHTML = html;
    return div.textContent || div.innerText || "";
  };

  // Helper: Truncate text to 2-3 lines
  const truncateText = (text, maxLength = 150) => {
    if (!text) return "";
    return text.length > maxLength ? text.slice(0, maxLength) + "..." : text;
  };
  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={courseDetailsToggleDrawer}
      sx={{ zIndex: 10 }}
    >
      <MotionBox
        initial={{ x: 100, opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        exit={{ x: 100, opacity: 0 }}
        transition={{ type: "spring", stiffness: 300, damping: 30 }}
        sx={{
          width: drawerWidth,
          p: 3,
          height: "100%",
          backgroundColor: "#fff",
          overflowY: "auto",
        }}
      >
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography
            variant="h6"
            sx={{
              fontWeight: "bold",
              mt: { xs: 10, sm: 10, md: 0 }, // xs/sm: margin-top 2, md and above: 0
            }}
          >
            Course Details
          </Typography>
          <IconButton onClick={courseDetailsToggleDrawer} color="error">
            <CloseIcon />
          </IconButton>
        </Box>

        <Divider sx={{ my: 2 }} />

        <Grid container spacing={2}>
          {[
            { label: "Title", value: course?.title },
            { label: "Brand", value: course?.brand?.brand_name },
            {
              label: "Description",
              value: truncateText(stripHtml(course?.description)),
            },
            { label: "Start Date", value: course?.start_date },
            { label: "Mode", value: course?.mode },
            { label: "Language", value: course?.language },
            { label: "Price", value: course?.price },
            { label: "Discount Price", value: course?.discount_price },
            {
              label: "Currency",
              value: `${course?.price_unit?.code || ""} ${
                course?.price_unit?.symbol || ""
              }`,
            },
            { label: "Max Students", value: course?.max_students },
            { label: "Level", value: course?.level },
            { label: "Duration", value: course?.duration },
            { label: "Access Type", value: course?.access_type },
            {
              label: "Certificate Provided",
              value: course?.certificate_provided === 1 ? "Yes 🎓" : "No ❌",
            },
            {
              label: "Instructors",
              value:
                course?.instructors?.length > 0
                  ? [
                      ...new Set(
                        course.instructors
                          .map((i) => i.customer?.fname)
                          .filter(Boolean)
                      ),
                    ].join(", ")
                  : "N/A",
            },
          ].map((item, i) => (
            <Grid key={i} item xs={12}>
              <Typography sx={labelStyle}>{item.label}</Typography>
              <Typography sx={valueStyle}>{item.value || "N/A"}</Typography>
              <Divider sx={{ my: 1 }} />
            </Grid>
          ))}
        </Grid>
      </MotionBox>
    </Drawer>
  );
};

export default CourseDetailsDrawer;
